import { logError } from 'client/javascript/util/logger';
import { Select } from '@wework/ray-core';
import getClosestMarket from 'client/javascript/get_closest_market';

export async function setupMarketSelectField(id) {
  try {
    const select = document.getElementById(id);

    if (!select) {
      return;
    }

    const raySelect = Select.create(select);
    const { id: marketId } = await getClosestMarket();
    raySelect.set(marketId);

    return {
      marketSelectField: select,
      marketSelectFieldRayInstance: raySelect
    };
  } catch (err) {
    logError(`Failed to instantiate ${id} market select.`, err);
    return {};
  }
}
